export default __webpack_public_path__ + "static/149-1676cfe07288c302a3acab2efd62cbe3.jpg";